<script setup lang="ts">
import { computed } from 'vue'

const { isActive } = defineProps<{
  isActive: boolean
}>()

const transitionStyle = computed((): Record<string, any> => ({
  transition: 'opacity 1s',
  opacity: isActive ? 1 : 0,
  pointerEvents: isActive ? 'auto' : 'none',
}))
</script>

<template>
  <div
    class="absolute inset-0 flex items-center justify-center"
    :style="transitionStyle"
    :inert="!isActive"
  >
    <slot />
  </div>
</template>
